import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

type RadioButtonIconProps = SvgIconProps & {
  checked?: boolean;
};

export const RadioButtonIcon = memo(({ className, checked }: RadioButtonIconProps) => {
  return (
    <SvgIcon className={className} style={{ fontSize: 24 }} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="1" y="1" width="22" height="22" rx="11" stroke={colors.primary.main} strokeWidth="2" fill="none" />
      {checked && <circle cx="12" cy="12" r="5" fill={colors.secondary.main} />}
    </SvgIcon>
  );
});
